"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.kcpCertification = void 0;
exports.kcpCertification = function (axios) {
    return {
        postKcpCertifications: function (postKcpCertificationsRequest) {
            return axios.post('/kcp/certifications', postKcpCertificationsRequest);
        },
        getKcpCertificationsResultDecrypt: function (getKcpCertificationsResultDecryptRequest) {
            return axios.get('/kcp/certifications/result-decrypt', getKcpCertificationsResultDecryptRequest);
        }
    };
};
